import { IFormRegister } from 'routes/Main/type';

import Form from 'components/Form';
import RowContainer from '../../components/RowContainer';
import RowContent from './components/RowContent';

import { useState } from 'react';

interface Props extends IFormRegister {
  disabled?: boolean;
}

const Signature = (props: Props) => {
  const { disabled, register, control } = props;

  const labels = [
    { title: 'Chữ ký bệnh nhân', variable: 'sign' },
    { title: 'Ngày', variable: 'date' },
    { title: 'Chữ ký bác sĩ', variable: 'staff_sign' },
  ];

  return (
    <>
      <RowContainer xs={12}>
        {labels.map(({ title, variable }, _) => (
          <>
            {Array(2)
              .fill(0)
              .map(() => (
                <RowContent titleRatio={1.5} childrenRatio={2.5} />
              ))}
            {variable === 'date' ? (
              <RowContent
                key={variable}
                title={title}
                titleRatio={1.5}
                childrenRatio={2.2}
              >
                <Form.MuiTextField
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  required={false}
                  disabled={disabled}
                  {...register('hospitalization_info.date')}
                />
              </RowContent>
            ) : (
              <RowContent
                key={variable}
                title={title}
                titleRatio={1.5}
                childrenRatio={2.2}
              >
                <Form.MuiTextField
                  required={false}
                  disabled={disabled}
                  {...register(`hospitalization_info.${variable}`)}
                />
              </RowContent>
            )}
          </>
        ))}
      </RowContainer>
    </>
  );
};

export default Signature;
